// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1L4G4","header":"PatientQuestionnaire_header__3WuR0","info":"PatientQuestionnaire_info__1UG9O"};